import styles from './index.module.scss';
import { timeFormatter } from '@autopass-web/domain';
import SVG from 'react-inlinesvg';

interface ParkingTimeSectionProps {
  checkedInAt: string;
  checkedOutAt: string;
}

export const ParkingTimeSection = ({
  checkedInAt,
  checkedOutAt,
}: ParkingTimeSectionProps) => (
  <div className={styles.top}>
    <div className={styles.period}>
      <div className={styles.date}>{timeFormatter(checkedInAt, 'date')}</div>
      <div className={styles.time}>{timeFormatter(checkedInAt, 'day')}</div>
    </div>
    <SVG src="/assets/arrow-right.svg" className={styles.arrow} />
    <div className={styles.period}>
      <div className={styles.date}>{timeFormatter(checkedOutAt, 'date')}</div>
      <div className={styles.time}>{timeFormatter(checkedOutAt, 'day')}</div>
    </div>
  </div>
);
